import { Component, OnChanges} from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { AddressType, IAddressType } from '../models/enums/address-type.enum';
import { Country } from '../../Foundation/models/enums/country.enum';
import { County } from '../../foundation/models/enums/county.enum';
import { Jurisdiction } from '../../foundation/models/enums/jurisdiction.enum';
import { CustomerAddress } from '../models/customer-address.model';

@Component({
    selector: 'historical-customer-address',
    templateUrl: './historical-customer-address.html',
    inputs: ['customerNumber', 'addresses']
})

export class HistoricalCustomerAddressComponent extends BaseComponent implements OnChanges {
    public addresses: CustomerAddress[];
    public customerNumber: number;
    public viewableAddressTypes: IAddressType[];

    public addressTypes = new AddressType();
    private countries = new Country();
    private counties = new County();
    private states = new Jurisdiction();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        this.viewableAddressTypes = [];
        this.viewableAddressTypes.push(this.addressTypes.Physical);
        this.viewableAddressTypes.push(this.addressTypes.Mailing);
        if (this.customerNumber != null) {
            this.populateAddress(this.customerNumber);
        } else if (this.addresses !== undefined) {
            this.denormalizeData();
        }
    }

    ngOnChanges() {
        if (this.addresses !== undefined) {
            this.denormalizeData();
        }
    }

    populateAddress(customerNumberId: number) {
        this.customerService.getHistoricalCustomerAddressess(customerNumberId)
            .subscribe(result => {
                this.addresses = result;
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const address of this.addresses) {
            address.addressType = this.getValues(address.addressTypeId, this.addressTypes);
            address.country = this.getValues(address.countryId, this.countries);
            address.county = this.getValues(address.countyId, this.counties);
            address.state = this.getValues(address.jurisdictionId, this.states);
            // address.postalZipCode = this.zipCodePipe.transform(address.postalZipCode);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    addAddress() {
        const address = new CustomerAddress();
        this.addresses.push(address);
    }

    editAddress(id: number) {
        console.log('Edit address: ' + id);
    }
}
